<script setup lang="ts">
import BackgroundGradient from '@/components/BackgroundGradient.vue'
import UpsellModal from '@/components/UpsellModal.vue'

const { t } = useI18n()
const { getStoreSchedulingPlatformUrl, selectedStore } = useStore()
const { stores, user } = useLocalStorage()
const { send } = useEvent()

const isModalOpen = ref(false)

const openModal = () => {
  isModalOpen.value = true
  send('segment', 'product:new:clicked')
}

const helperCard = {
  title: t('pages.contests.contestsCreatePage.upsell.modal.steps.title'),
  steps: [
    t('pages.contests.contestsCreatePage.upsell.modal.steps.1'),
    t('pages.contests.contestsCreatePage.upsell.modal.steps.2'),
    t('pages.contests.contestsCreatePage.upsell.modal.steps.3'),
    t('pages.contests.contestsCreatePage.upsell.modal.steps.4')
  ]
}

const schedulingPlatform = computed(() => {
  const routeParams = '?utm_source=pongo&utm_medium=dashboard&utm_campaign=upsell&utm_content='
  const url = `${getStoreSchedulingPlatformUrl(selectedStore.value)}${routeParams}booster`
  return url
})

const successModal = {
  title: t('pages.contests.contestsCreatePage.upsell.modal.success.title'),
  text: t('pages.contests.contestsCreatePage.upsell.modal.success.text'),
  linkText: t('pages.contests.contestsCreatePage.upsell.modal.success.linkText')
}

const boosterPrice = 69

const activateModule = (selectedStores) => {
  selectedStores.map((selectedStore) => {
    const storeData = stores.value.find((store) => store.id === selectedStore.storeId)

    const data = {
      merchantPublicId: user.value.merchant.publicId,
      merchantName: user.value.merchant.name,
      crmOwnerIdentifier: storeData.ownerCsm?.crmContactIdentifier.toString(),
      crmDealIdentifier: storeData.businessCrmIdentifier?.toString(),
      crmCompanyIdentifier: user.value.merchant?.businessCrmIdentifier?.toString(),
      storePublicId: storeData.public_id,
      storeName: storeData.name,
      product: {
        productName: 'booster',
        price: boosterPrice,
        quantity: 1
      }
    }

    send('segment', 'product:create:clicked', data)
  })
}

const links = {
  reminder: schedulingPlatform.value,
  activate: '#'
}
</script>

<template>
  <BackgroundGradient
    :has-caret="true"
    position="fixed bottom-0 w-full left-0 sm:absolute sm:w-auto sm:bottom-auto sm:top-16 sm:-left-10 lg:right-0 lg:left-auto"
  >
    <div class="py-4">
      <div class="flex w-80 items-start gap-2">
        <BaseIcon name="HeroArrowUpCircleIconSolid" class="w-8 text-primary" />
        <div class="text-sm">
          <h2 class="mb-1 font-semibold text-foreground">
            {{ t('pages.contests.contestsCreatePage.upsell.title') }}
          </h2>
          <p class="text-muted-foreground">{{ t('pages.contests.contestsCreatePage.upsell.description') }}</p>
        </div>
      </div>
      <Button variant="default-primary" class="mt-4 w-full leading-6 sm:leading-normal" @click="openModal">
        {{ t('pages.contests.contestsCreatePage.upsell.button') }}
      </Button>
    </div>
  </BackgroundGradient>
  <UpsellModal
    :show="isModalOpen"
    :helper-card="helperCard"
    :links="links"
    :success="successModal"
    :title="t('pages.contests.contestsCreatePage.upsell.modal.title')"
    :pricing="boosterPrice"
    @on-close-modal="isModalOpen = false"
    @on-activate="activateModule"
  />
</template>
